export const ChatActionsIT = [
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😳</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😭</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😰</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😍</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">❓</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🤐</span>'
      }
    ],
    action: 'next'
  },
  {
    type: 'double',
    content: [
      {
        text: 'Obesità',
        isCorrect: true
      },
      {
        text: 'Denutrizione',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">😱</span>'
      }
    ]
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">💁</span>'
      }
    ]
  },
  {
    type: 'double',
    content: [
      {
        text: '1,000 tonnellate',
        isCorrect: false
      },
      {
        text: '1 milione di tonnellate',
        isCorrect: false
      },
      {
        text: '1.3 miliardi di tonnellate',
        isCorrect: true
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">🙀</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🤔</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">😑</span>'
      }
    ]
  },
  {
    type: 'single',
    content:[
      {
        text: '<span class="emoji">🙋</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">✍️</span>'
      }
    ]
  },
  {
    type: 'openBadges',
    content: [
      {
        text: 'Ok, ho capito!'
      }
    ],
    action: 'sdg'
  },
  {
    type: 'single',
    content: [
      {
        text: '😋'
      }
    ]
  },
  {
    type: 'openOverlay',
    content: [
      {
        text: '<span class="emoji">💪</span> Sono nato/a pronto/a!'
      }
    ],
    action: 'openCardsGame'
  },
  
  {
    type: 'single',
    content: [
      {
        text: 'Andiamo!'
      }
    ]
  },
  {
    type: 'double',
    content: [
      {
        text: 'Metà in aree rurali e metà in aree urbane',
        isCorrect: true
      },
      {
        text: 'In aree rurali',
        isCorrect: false
      },
      {
        text: 'In aree urbane',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: '5 su 10',
        isCorrect: false
      },
      {
        text: '7 su 10',
        isCorrect: true
      },
      {
        text: '9 su 10',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: '25',
        isCorrect: false
      },
      {
        text: '40',
        isCorrect: true
      },
      {
        text: '33',
        isCorrect: false
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: '150,000 ',
        isCorrect: false
      },
      {
        text: '1 milione',
        isCorrect: false
      },
      {
        text: '2 milione',
        isCorrect: true
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'double',
    content: [
      {
        text: 'Un’istituzione che si occupa soprattutto di finanziare aziende del settore alimentare',
        isCorrect: false
      },
      {
        text: 'Una banca che segue i prezzi delle scorte alimentari',
        isCorrect: false
      },
      {
        text: 'Un ente di beneficenza che si occupa di riciclo e ridistribuzione delle eccedenze alimentari',
        isCorrect: true
      }
    ],
    action: 'show-answer'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">✌</span>'
      }
    ]
  },
  {
    type: 'openOverlay',
    content: [
      {
        text: 'Andiamo!'
      }
    ],
    action: 'openPyramid'
  },
  {
    type: 'openOverlay',
    content: [
      {
        text: '<span class="emoji">💃</span> SÌÌÌÌ! '
      }
    ],
    action: 'openVirtualDishes'
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🙌</span>'
      }
    ]
  },
  {
    type: 'single',
    content: [
      {
        text: '<span class="emoji">🥰</span>'
      }
    ]
  },
  {
    type: 'openBadges',
    content: [
      {
        text: '<span class="emoji">🙌</span>'
      }
    ],
    action: 'chat'
  }
  
]